export const sanitizeScriptTag = (str: string): string => {
    return str.replace(/(<(\/|)script>)/g, '');
};